import { useContext } from 'react';

import { NIGHTS } from 'contexts/CruiseSearchContext/constants';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';

import NightPill from '../NightPill';

import styled from 'styled-components';
import colors from 'styles/colors';
import classnames from 'classnames';
import { SectionTitle } from 'components/FiltersModal/components';

import { getBrandUISettings } from 'lib/utilities/Brands';

const NightsContainer = styled.section`
  background-color: ${colors.primary.ice};
  left: 0;
  padding: 0;
  width: 100%;
  z-index: 2;
`;

const PillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ gap }) => gap};
`;

const OverPill = styled.div`
  display: flex;

  &.disabled {
    opacity: 0.25;
    pointer-events: none;
  }
`;

// gte stands for greather than or equals.
// lt, lte, gt and weekend cruises can be added.
const ranges = ['2~5', '6~8', '9~11', 'gte12'];

const changeRangeFormat = range => {
  let renderedRange = range.replace(/~/g, ' - ');
  renderedRange = renderedRange.includes('gte')
    ? `${renderedRange.split('gte')[1]} +`
    : renderedRange;

  return renderedRange;
};

const NightsSelector = () => {
  const {
    updateSearchSelectingFilter,
    searchSelecting,
    facetOptions,
    fetchAndUpdateFacetOptions,
    globalization,
    brand,
  } = useContext(CruiseSearchContext);

  const { uiSettings } = getBrandUISettings(brand);
  const { filtersDictionary } = globalization?.dictionaries || {};
  const { labelLengthOfCruise } = filtersDictionary;

  const nights = searchSelecting[NIGHTS] || [];

  const checkAvailableNights = range => {
    if (facetOptions.nights) {
      const arrayNigths = Object.values(facetOptions?.nights);
      let filterRange = [];
      if (range.includes('12')) {
        filterRange = arrayNigths.filter(e => {
          return Number(e.code) >= '12' && e.count > 0;
        });
      } else {
        let splitRange = range.split('~');
        filterRange = arrayNigths.filter(e => {
          return (
            Number(e.code) >= Number(splitRange[0]) &&
            Number(e.code) <= Number(splitRange[1]) &&
            e.count > 0
          );
        });
      }
      return !(filterRange.length > 0);
    }
  };

  const handleClick = range => {
    const updatedNights = nights.includes(range)
      ? nights.filter(night => night !== range)
      : [...nights, range];

    updateSearchSelectingFilter(
      NIGHTS,
      updatedNights,
      fetchAndUpdateFacetOptions,
    );
  };

  return (
    <NightsContainer>
      <SectionTitle title={labelLengthOfCruise} />
      <PillContainer gap={uiSettings.filtersModal.filtersGrid.gap}>
        {ranges.map(range => {
          return (
            <OverPill
              key={range}
              className={classnames({
                disabled: checkAvailableNights(range),
              })}
            >
              <NightPill
                key={range}
                onClick={() => handleClick(range)}
                selected={nights.includes(range)}
              >
                {changeRangeFormat(range)}
              </NightPill>
            </OverPill>
          );
        })}
      </PillContainer>
    </NightsContainer>
  );
};

export default NightsSelector;
